<template>
    <div class="input-contain">
        <v-text-field
            @input="$emit('input', $event)"
            :value="value"
            :v-mask="mask"
            :input-value="value"
            :append-icon="type === 'password' ?  show ? 'mdi-eye' : 'mdi-eye-off' : ''"
            height="44"
            :show_password="show"
            :placeholder="placeholder"
            @click:append="show = !show"
            class="input-text"
            :required="required"
            content-class="input-text__content"
            :type="type === 'password' && show ? 'password' : type === 'password' && !show ? 'text' : type"
            :rules="rules || []"
            hide-details="auto"
            :clearable="clearable"
            :disabled="disabled"
            :label="label"
            :color="color"
        ></v-text-field>
        <span class="hint">{{hint}}</span>
    </div>
</template>

<script>

export default {
	name: 'UiInput',
    data: () => ({
        show: true
    }),
    props:{
        value:{
            required: true
        },
        placeholder:{
            type: String,
            default: ''
        },
        clearable:{
            type: Boolean,
            default: false
        },
        hint:{
            type: String,
            default: ''
        },
        mask:{
            type: String,
            default: ''
        },
        required:{
            type: Boolean,
            default: false
        },
        type:{
            default: 'text'
        },
        label:{
            type: String,
            default: ''
        },
        disabled:{
            type: Boolean,
            default: false
        },
        rules:{
            required: false
        },
        color:{
            type: String,
            default: 'grey'
        },
        show_password:{
            type: Boolean,
            default: false
        },
    },
}
</script>

<style scoped>
    .input-contain .v-input input {
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 148%;
    }
    .input-contain .input-placeholder {
        margin-right: 1em;
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 148%;
        text-align: right;
        color: #8992b5;
    }
    
    @media (min-width: 850px) {
        .input-contain .v-input input {
            font-size: 21px;
        }
        .input-contain .auto-placeholder {
            font-size: 21px;
        }
    }
    @media (max-width: 1650px) {
        .input-contain .v-input input {
            font-size: 20px;
        }
        .input-contain .auto-placeholder {
            font-size: 20px;
        }
    }
    @media (max-width: 1350px) {
        .input-contain .v-input input {
            font-size: 20px;
        }
        .input-contain .auto-placeholder {
            font-size: 20px;
        }
    }
    @media (max-width: 850px) {
        .input-contain .v-input input {
            font-size: 14px;
        }
        .input-contain .auto-placeholder {
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// UiInput.vue?275aca88